import React from 'react'
import { colors } from '../../../styles/vars/colors.style'

const DottedVerticalLine = ({
  width = 5,
  height = 57,
  stroke = colors.light,
  responsive = false,
}) => {
  const svgAttributes = responsive
    ? {}
    : {
        width,
        height,
      }

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 5 57"
      focusable="false"
      role="img"
      {...svgAttributes}
    >
      <circle cx="2.5" cy="3.5" r="2.5" fill={stroke}/>
      <path
        stroke={stroke}
        strokeDasharray="2 2"
        d="M2.5 4v53"/>
    </svg>
  )
}

export default DottedVerticalLine
